var map = {
	"./Minus.svg": 3932,
	"./Plus.svg": 1732,
	"./avatar_five.svg": 6322,
	"./avatar_four.svg": 9322,
	"./avatar_one.svg": 6794,
	"./avatar_six.svg": 7642,
	"./avatar_three.svg": 7458,
	"./avatar_two.svg": 3348,
	"./case_reports.svg": 3752,
	"./clients.svg": 5136,
	"./down-arrow.svg": 1300,
	"./edit.svg": 9648,
	"./empty_case_report.svg": 2099,
	"./empty_client.svg": 9063,
	"./empty_summary_report.svg": 4763,
	"./follow_ups.svg": 9372,
	"./left_arrow_black.svg": 3909,
	"./left_arrow_long_blue.svg": 7585,
	"./right_arrow_black.svg": 4692,
	"./right_arrow_grey.svg": 4930,
	"./sessions.svg": 9907,
	"./summary.svg": 5516,
	"./up-arrow.svg": 7511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8548;